import React, { useState } from 'react';

var d = new Date();
var currYear = d.getFullYear();
const Footerdetail = (props) => {
  return (
    <>
      <div id='footerdetail' >
      
        <div className='container text-center'>
          <p>
            Copyright  {currYear}. All rights reserved &copy; RO Service Solution{' '} | <a href='/privacy-policy' >Privicy Policies</a>
          </p>
        </div>

      </div>
    </>
  )
}

export default Footerdetail;